<template>
<div class="container is-marginless shop is-fluid ">



  <div class="columns shop-row">
    <component :is="activeComponent" link="http://ethelvaughn.com/product/baragon-jumper/" title="Baragon Jumper" price="€219.00" offset="4" src="1" border borderSlice="199" color="fd9aa4">
    </component>
  </div>


  <div class="columns shop-row">
    <offsetColumn offset="1" width="4" align="center">
      <creditElement credit="Collaborator: <a href='https://www.instagram.com/jonas_stadter' target='_blank'>@Jonas_Stadter</a>">
        <video autoplay playsinline muted loop>
          <source :src="videos(1,'mp4')"  type="video/mp4">
          <source :src="videos(1,'webm')"  type="video/webm">
        </video>
      </creditElement>
    </offsetColumn>
  </div>

  <div class="columns shop-row">
    <component :is="activeComponent" link="http://ethelvaughn.com/product/gomora-bomber/" title="Gomora Bomber" price="€369.00" offset="2" src="6" hasBackside color="000000">
    </component>
  </div>

  <div class="columns shop-row">
    <component :is="activeComponent" link="http://ethelvaughn.com/product/gargantuas-dungarees/" title="Gargantuas Dungarees" price="€349.00" offset="4" src="7" color="b4a8e7">
    </component>
  </div>

  <div class="columns shop-row">
    <component :is="activeComponent" link="http://ethelvaughn.com/product/manda-hoodie/" title="Manda Hoodie" price="€229.00" bgOffset="60" offset="6" src="14" color="cbac80">
    </component>
  </div>

  <div class="columns shop-row">
    <offsetColumn offset="7" width="4" align="center">
      <creditElement credit="Collaborators: <a href='https://www.instagram.com/obby1000/' target='_blank'>@obby1000</a> and <a href='https://www.instagram.com/japparii/' target='_blank'>@japparii</a>">
        <hoverableImage :sources="[images('obby_1'), images('obby_2')]"></hoverableImage>
      </creditElement>
    </offsetColumn>
  </div>

  <div class="columns shop-row">
    <component :is="activeComponent" link="http://ethelvaughn.com/product/gojira-hoodie/" link2="http://ethelvaughn.com/product/magma-baggy-pants/" title="Gojira Hoodie" price="€249.00" price2="€289.00" title2="Magma Baggy Pants" offset="7" src="11" hasBackside
      color="9c9c9c">
    </component>
  </div>

  <div class="columns shop-row">
    <component :is="activeComponent" link="http://ethelvaughn.com/product/oodako-jumper/" title="Oodako Jumper" price="€169.00" bgOffset="60" offset="5" src="10" color="858585">
    </component>
  </div>

  <div class="columns shop-row">
    <component :is="activeComponent" link="http://ethelvaughn.com/product/baby-godzilla-hoodie/" title="Baby Godzilla Hoodie" price="€269.00" offset="4" src="15" color="000000">
    </component>
  </div>

  <div class="columns shop-row">
    <offsetColumn offset="5" width="4" align="center">
      <creditElement credit="Collaborator: <a href='https://www.instagram.com/jonas_stadter' target='_blank'>@Jonas_Stadter</a>">
        <video autoplay playsinline muted loop>
          <source :src="videos(0,'mp4')"  type="video/mp4">
          <source :src="videos(0,'webm')"  type="video/webm">
        </video>
      </creditElement>
    </offsetColumn>
  </div>

  <div class="columns shop-row">
    <component :is="activeComponent" link="http://ethelvaughn.com/product/oodabi-hoodie/" title="Oodabi Hoodie" price="€169.00" bgOffset="20" offset="6" src="5" color="3d3d3d">
    </component>
  </div>

  <div class="columns shop-row">
    <component :is="activeComponent" link2="http://ethelvaughn.com/product/dogora-baggy-pants/" title2="Dogora Baggy Pants" price2="€269.00" link="http://ethelvaughn.com/product/kameba-hoodie/" title="Kameba Hoodie" price="€239.00" offset="4" bgOffset="20"
      src="12" hasBackside color="000000">
    </component>
  </div>

  <div class="columns shop-row">
    <component :is="activeComponent" link="http://ethelvaughn.com/product/ganime-hoodie/" title="Ganime Hoodie" price="€229.00" offset="2" src="9" border hasBackside borderSlice="349" color="e38797">
    </component>
  </div>

  <div class="columns shop-row">
    <component :is="activeComponent" link="http://ethelvaughn.com/product/gigan-sweatpants/" title="Gigan Sweatpants" price="€219.00" offset="1" bgOffset="20" src="8" color="aa7945">
    </component>
  </div>

  <div class="columns shop-row">
    <offsetColumn offset="2" width="4" align="center">
      <creditElement credit="Collaborator: <a href='https://www.instagram.com/jonas_stadter' target='_blank'>@Jonas_Stadter</a>">
        <img :src="images( 'lookbook_11' )"></img>
      </creditElement>
    </offsetColumn>
  </div>

  <div class="columns shop-row">
    <component :is="activeComponent" link="http://ethelvaughn.com/product/varan-zipper-hoodie/" title="Varan Zipper Hoodie" price="€329.00" offset="3" src="4" color="0784f3">
    </component>
  </div>

  <div class="columns shop-row">
    <component :is="activeComponent" link2="http://ethelvaughn.com/product/nezumi-leggings/" title2="Nezumi Leggings" price2="€89.00" link="http://ethelvaughn.com/product/mothra-jumper/" title="Mothra Jumper" price="€249.00" offset="4" bgOffset="20" src="16"
      hasBackside color="1e1712">
    </component>
  </div>


  <div class="columns shop-row">
    <component :is="activeComponent" link="http://ethelvaughn.com/product/angilas-trackpants/" title="Angilas Trackpants" price="€229.00" offset="6" src="3" color="000000">
    </component>
  </div>








</div>
</template>

<script>
import offsetColumn from '@/components/layout/_columnWithOffset.vue';
import offsetColumnBg from '@/components/layout/_columnWithOffsetBackground.vue';
import offsetColumnImg from '@/components/layout/_columnWithOffsetImgMobile.vue';
import creditElement from '@/components/layout/_creditsElement.vue';
import hoverableImage from '@/components/layout/_hoverableImage.vue';
import lazyImage from '@/components/layout/_lazyImage.vue';

export default {
  name: 'shop',
  data() {
    return {

    }
  },
  computed: {
    activeComponent() {
      if (this.$root.isMobile) {
        return 'offsetColumnImg'
      } else {
        return 'offsetColumnBg'
      }
    }
  },
  mounted() {

  },
  methods: {
    images(r) {
      return require('@/assets/images/' + r + '.png')
    },
    videos(num, format) {
      return require('@/assets/images/lookbook/lookbook_' + num + '.' + format)
    },
  },
  components: {
    offsetColumn,
    lazyImage,
    offsetColumnBg,
    offsetColumnImg,
    creditElement,
    hoverableImage
  }
}
</script>

<style lang="scss" >
.column div {
    /* background: grey; */
}

.lookbook-bg-container {
    // height: 100vh;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    // background-position: center !important;
    width: 100%;
    position: relative;
}
.shop {
    padding-bottom: 10rem;
    padding-top: 10rem;
    z-index: 0;
    // transition: height ease;
    will-change: height;
}
.shop-row {
    // height: 100vh;
    // padding-bottom: 25vh;
    padding-top: 25vh;
}
.shop-row {
    // opacity: 0;
    // display: none;
    // transition: opacity 0.3s;
}
.shop-row.in-viewport {
    // opacity: 1;
    // display: block;
}
h1 {
    padding: 2rem 0;
}
// .transition {
//     transition: all 1s ease 200ms;
// }
// .transition-to-center {
//     position: fixed;
//     top: 0;
//     text-align: center;
//     left: 50%;
//     width: 100% !important;
//     padding: 0;
//     margin: 0 !important;
//     transform: translateX(-50%);
// }

@media screen and (max-width: 600px) {
    .shop-row {
        // min-height: 120vh;
    }
}
</style>
